import React, { useState } from 'react';
import Calendar from 'react-calendar';

import 'react-calendar/dist/Calendar.css';
import './Scheduling.css'; // Optional: Add custom styles here

const Scheduling = () => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [unavailableDates, setUnavailableDates] = useState([
        new Date(2023, 9, 15), // Example unavailable dates
        new Date(2023, 9, 20),
    ]);

    const handleDateChange = (date) => {
        if (!isDateUnavailable(date)) {
            setSelectedDate(date);
            setUnavailableDates([...unavailableDates, date]);
        }
    };

    const isDateUnavailable = (date) => {
        return unavailableDates.some(
            (unavailableDate) =>
                unavailableDate.toDateString() === date.toDateString()
        );
    };

    return (
        <div className="scheduling-container">
            <h1>Schedule Fire Alarm Inspection</h1>
            <p>Select a date for your inspection:</p>
            <div className={"center-top"}>
            <Calendar
                onChange={handleDateChange}
                value={selectedDate}
                tileDisabled={({ date }) => isDateUnavailable(date)}
            />
            </div>

            {selectedDate && (
                <p>
                    You have selected: <strong>{selectedDate.toDateString()}</strong>
                </p>
            )}
        </div>
    );
};

export default Scheduling;